//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const MediaByID = createAsyncThunk(
  "MediaByID",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingMediaByID(""));
      const response = await UsePortalApi(
        `Patient/MediaByID`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingMediaByIDSuccess(response[0].entry)) : dispatch(gettingMediaByIDClear())

      } else {
        dispatch(
          gettingMediaByIDFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingMediaByIDFailed(error));
    }
  }
);
const MediaByIDSlice = createSlice({
  name: "MediaByID",
  initialState: {
    MediaByIDData: null,
    isMediaByIDData: false,
    isMediaByIDError: false,
  },
  reducers: {
    gettingMediaByID: (state, action) => {
      state.MediaByIDData = null;
      state.isMediaByIDData = true;
      state.isMediaByIDError = false;
    },
    gettingMediaByIDSuccess: (state, action) => {
      state.MediaByIDData = action.payload;
      state.isMediaByIDData = false;
      state.isMediaByIDError = false;
    },
    gettingMediaByIDFailed: (state, action) => {
      state.MediaByIDData = null;
      state.isMediaByIDData = false;
      state.isMediaByIDError = true;
    },
    gettingMediaByIDClear: (state, action) => {
      state.MediaByIDData = null;
      state.isMediaByIDData = false;
      state.isMediaByIDError = false;
    },
  },
});
export const {
  gettingMediaByID,
  gettingMediaByIDSuccess,
  gettingMediaByIDFailed,
  gettingMediaByIDClear,
} = MediaByIDSlice.actions;
export default MediaByIDSlice.reducer;
